import { useDndContext } from '@dnd-kit/core';
import { cn } from '@whalar/ui/src/lib/utils';
import { useMemo } from 'react';

import { getEmbedUrl, getVideoPlatform } from '../modals/VideoUrlModal/utils';

export interface TalentVideoProperties {
  url: string;
}

export const TalentVideo = ({ url }: TalentVideoProperties) => {
  const embedUrl = useMemo(() => getEmbedUrl(url), [url]);
  const dndContext = useDndContext();

  const platform = useMemo(() => {
    return getVideoPlatform(url);
  }, [url]);

  const isPortrait = platform === 'instagram' || platform === 'tiktok';

  // Set container classes based on aspect ratio and platform
  const containerClasses = cn('relative w-full overflow-hidden mx-auto group');

  return (
    <div className={containerClasses} data-testid="talent-video-container">
      <iframe
        src={embedUrl}
        allowFullScreen
        loading="lazy"
        title="video"
        className={cn('w-full h-full border-0 rounded-12', {
          'max-w-[500px] mx-auto !h-[850px]': isPortrait,
          '!h-[721px]': platform === 'tiktok',
          'aspect-video': !isPortrait,
          'pointer-events-none': Boolean(dndContext.active?.id), // Improves drag performance
        })}
      />
    </div>
  );
};
